const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"!]+(\.[^<>()[\]\\.,;:\s@"!]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const validateEmail = (email: string) => {
  return email ? emailRegex.test(email.trim()) : false
}
